module.exports = "/_next/static/images/CompleteDataCollectedMobile@2x-6605bb44a5498067e3eac92df885276d.png";